import { render, staticRenderFns } from "./facets-list.view.vue?vue&type=template&id=0069920a&scoped=true"
import script from "./facets-list.view.vue?vue&type=script&lang=ts"
export * from "./facets-list.view.vue?vue&type=script&lang=ts"
import style0 from "./facets-list.view.vue?vue&type=style&index=0&id=0069920a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069920a",
  null
  
)

export default component.exports